<template>
  <div class="questionBox">
    <loading :active.sync="isLoading"
      :can-cancel="false"
      loader="dots"
      color="#1f9ed3"
      :is-full-page="fullPage"></loading>
    <header class="header-banner">
      <img class="activeImg" src="../assets/image/active2019.jpg" alt="active">
      <div class="activeImg_tips">0h ngày 05/11/2018 đến 0h ngày 30/06/2019</div>
    </header>
    <h3>
      Chỉ bằng cách điền các thông tin dưới đây sẽ có thể tham gia chương trình khuyến mại cùng
      <a href="http://www.vngaynay.vn" target="blank">www.vngaynay.vn</a> và có cơ hội nhận xe máy Wave RSX FI 2017 hoặc Điện thoại iPhone X 64GB Gray!
    </h3>
    <main class="main-form">
    <form name="userInfo">
      <table class="main-table">
        <tr>
          <td>Họ tên *:</td>
          <td><input type="text" value="" v-model="name"/></td>
        </tr>
        <tr>
          <td>Số CMND*:</td>
          <td><input type="text" value="" v-model="cardid"/></td>
        </tr>
        <tr>
          <td>Di động*:</td>
          <td><input type="text" value="" v-model="cellphone" /></td>
        </tr>
        <tr>
          <td>Email*:</td>
          <td><input type="text" value="" v-model="email" /></td>
        </tr>
      </table>
      <div class="control">
        <button type="button" class="submitBtn" @click="submitInfo($event)">Gửi</button>
        <a @click="goHome">Bỏ qua>></a>
      </div>
      </form>
    </main>
    <p>Tìm hiểu thêm về thể lệ chương trình khuyến mại <a @click="jumpActive">tại đây</a>!</p>
  </div>
</template>
<script>
import * as cookies from "js-cookie";
import { Button, MessageBox } from "element-ui";
 // Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import lang from "element-ui/lib/locale/lang/th";
import locale from "element-ui/lib/locale";
locale.use(lang);

export default {
  name: "Register",
  data() {
    return {
      name:'',
      cardid:"",
      cellphone:'',
      email:"",
      isLoading:false,
      fullPage:true
    };
  },
  components: {
    Loading
  },
    mounted() {
    MessageBox.alert('Nhằm đem đến trải nghiệm tốt nhất cho người dùng, hệ thống xin thông báo, chương trình "Mỗi tuần 01 xe máy" sẽ tạm ngưng hoạt động vào ngày 02/07/2019. Chương trình mới sẽ mở sớm nhất có thể. Cảm ơn sự ủng hộ của các bạn trong thời gian qua.',"Thông báo",
    {
      dangerouslyUseHTMLString:true,
      center:true
    })
  },
  methods: {
    submitInfo(e) {
      return;
      const that=this;
      this.isLoading=true;
      e.preventDefault();
      let userInfo ={
        name:this.name,
        cardid:this.cardid,
        cellphone:this.cellphone,
        email:this.email,
        fid:cookies.get('fid')
      }
      if(!userInfo.fid){
        MessageBox.alert('please login with facebook first !','Thông báo')
        this.isLoading=false;
        return;
      }
      let config={
        headers:{
          'Content-Type': 'multipart/form-data'
        }
      }
      let xhr=new XMLHttpRequest();
      xhr.onreadystatechange=function(){
        if(xhr.status==200&&xhr.readyState==4){
          let res=JSON.parse(xhr.response);
          that.isLoading=false;
          const {lottery,errcode}=res;
          if(errcode===1){
            MessageBox.alert('Bạn đang tham gia chương trình tuần này, không thể lặp lại, xin đợi tới tuần sau',"Thông báo")
          }else{
            cookies.set('cur_ticketid',lottery.lottery);
            cookies.set('cur_issue',lottery.issue);
            MessageBox.alert('Tham gia thành công!','Thông báo').then(()=>{
              that.$router.push("/activedetail");
            })
          }
        }
      }
      xhr.open('post','/submit');
      xhr.setRequestHeader('Content-Type','application/json');
      xhr.send(JSON.stringify(userInfo));
    },
    jumpActive() {
      this.$router.push({ path: "/introduction" });
    },
    goHome() {
      this.$router.push("/");
    }
  }
};
</script>
<style scoped>
.questionBox {
  display: block;
  position: relative;
  width: 60%;
  margin: 0 auto;
  text-align: center;
  padding: 0;
}
.questionBox h3,
.questionBox h4 {
  color: #000000;
  width: 100%;
  margin: 0 auto;
  padding: 0;
  margin-bottom: 10px;
}
.activeImg {
  display: inline-block;
}
.header-banner {
  position: relative;
}
.activeImg_tips {
  position: absolute;
  bottom: 30px;
  left: 20px;
  font-size: 18px;
}
.main-form {
  display: block;
  position: relative;
  width: 860px;
  margin: 20px auto;
  padding: 10px 30px;
}
.main-table {
  display: inline-block;
}
.main-form input {
  display: inline-block;
  width: 400px;
}

.main-form input {
  display: inline-block;
  margin: 2px 4px;
  padding: 4px;
  border: 1px solid #cccccc;
  border-radius: 5px;
}
.submitBtn {
  display: inline-block;
  margin: 4px 2px;
  padding: 6px 8px;
  width: 100px;
  border-radius: 8px;
  background-color: #ffffff;
}
.control a {
  display: inline-block;
  margin: 4px 2px;
  padding: 6px 8px;
  float: right;
  cursor: pointer;
}
</style>




// WEBPACK FOOTER //
// Register.vue?b26f723c